import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84f1dffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "services" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "main-title container" }, "Услуги", -1))
const _hoisted_3 = { class: "services__all-items" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "services__all-items-empty-block is-left" }, null, -1))
const _hoisted_5 = { class: "services__all-items-inner" }
const _hoisted_6 = { class: "services__item services-item" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<h3 class=\"services-item__title\" data-v-84f1dffa>КОНЦЕПТ-ДИЗАЙН</h3><p class=\"services-item__main-text\" data-v-84f1dffa> Услуга для тех, кто хочет получить чёткое визуальное видение будущего пространства — быстро и без лишних технических деталей. Идеально подходит, если вы хотите утвердить общую концепцию, прежде чем двигаться дальше, или планируете реализовывать проект самостоятельно / с собственной бригадой. </p><p class=\"services-item__text\" data-v-84f1dffa>Что входит в концепт-дизайн?</p><ul class=\"services-item__list services-list\" data-v-84f1dffa><li data-v-84f1dffa>Обмерный план (составляется на основе размеров и планировки, предоставленных клиентом)</li><li data-v-84f1dffa>Визуализация интерьера (фотореалистичные изображения по ключевым ракурсам)</li></ul><p class=\"services-item__annotation\" data-v-84f1dffa> Цена -  <span data-v-84f1dffa>1500р</span>./м2 </p>", 5)
const _hoisted_12 = { class: "services__item services-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "services-item__title" }, "ДИЗАЙН-ПРОЕКТ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "services-item__main-text" }, " Комплексное решение полного цикла — от идеи до готовой технической документации для строителей и ремонтной бригады. Вы получаете не просто «картинку», а исчерпывающий пакет документов, с которым можно приступать к реализации без дополнительных вопросов и простоев на объекте. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "services-item__text" }, "Что входит в дизайн-проект?", -1))
const _hoisted_16 = { class: "services-item__list services-list" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Технический выезд на замер", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Обмерный план", -1))
const _hoisted_19 = { class: "services-list__tooltip-wrapper" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План монтажа\\демонтажа", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План сантехники", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План напольных покрытий", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План теплого пола", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План потолока", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План дверей", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План расстановки мебели", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План электрики", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "План разверток", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Визуализации", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "3D-тур", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "services-item__annotation" }, [
  /*#__PURE__*/_createTextVNode(" Цена -  "),
  /*#__PURE__*/_createElementVNode("span", null, "2500р"),
  /*#__PURE__*/_createTextVNode("./м2 ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "services__all-items-empty-block is-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppTooltip = _resolveComponent("AppTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_AppButton, {
            theme: "dark",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToBlock('request-form')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Получить консультацию ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("ul", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_19, [
                _createTextVNode(" Архитектурно-отделочные чертежи "),
                _createVNode(_component_AppTooltip, null, {
                  content: _withCtx(() => [
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_29,
            _hoisted_30
          ]),
          _hoisted_31,
          _createVNode(_component_AppButton, {
            theme: "dark",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToBlock('request-form')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Получить консультацию ")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_32
    ])
  ]))
}